import React from 'react';
import {WorkPercentage } from '../../Objects/Project';
import DynamicTable from '../tables/DynamicTable';

interface ResourcePlanningBoxProps {
    title: string;
    project: any[];
}

const ResourcePlanningBox = ({ title, project } : ResourcePlanningBoxProps) => {
    return (
        <>
        <div className="box">
            <h3>Werk Percentages</h3>
            <DynamicTable
            data={project}
            columns={[
                {id: 1 ,label: "Contact" ,property: "member.name"},
                {id: 10,label: "Contract", property:'contract.name'},
                {id: 11,label: "Defiscalisatie", property:'defiscalization'},
                {id: 3 ,label: "Van", property:'from'},
                {id: 4 ,label: "Tot", property:'to'},
                {id: 5 ,label: "Unit", property:'businessUnit.name'},
                {id: 6 ,label: "Working %", property:'workingPercentage'},
                {id: 2 ,label: "Paid %", property:'paidPercentage'},
                {id: 7 ,label: "Type", property:'memberType.name'},
                {id: 8 ,label: "Funding Channel", property:'fundingChannel.name'},
                {id: 9 ,label: "Knowledge Group", property:'knowledgeGroup.name'},
                ]}
            />
        </div>
        </>
    );
};

export default ResourcePlanningBox;
